import {useGetExamConfigQuery} from "../../../../../store/api/examConfigApiSlice";
import {Navigate, useParams} from "react-router-dom";

export default function ProblemsetChapterIncomplete() {
  const {examPath, subjectId} = useParams();
  const {data} = useGetExamConfigQuery();

  // Find selected subject and chapter
  const selectedSubject = data?.problemsetFilters.subjects.find(
    subject => subject.subjectId === subjectId,
  );

  const selectedChapter = selectedSubject?.chapters.find(
    chapter => chapter.isSelected,
  );

  // Redirect to specific route if both subject and chapter are selected
  if (selectedSubject && selectedChapter && examPath) {
    return (
      <Navigate
        to={`/${examPath}/${selectedSubject.subjectId}/${selectedChapter.chapterId}`}
        replace
      />
    );
  }

  // Default redirect to home
  return <Navigate to="/" replace />;
}
